import React from 'react';

import { useTranslation } from 'react-i18next';

import { useDispatch } from 'react-redux';
import { logout as doLogout } from '@redux/auth/auth-action';

import Modal from '@common/modal/modal';
import { WOLFE_API } from '@config/endpoints';

import BoonButterflyIcon from '@assets/svg/boon-butterfly.svg';
import styles from './modal.styles';

import { hideModal } from '@redux/modal/modal-dispatcher';
import { useRouter } from 'next/router';
import BoonButton from '../../button/boon-button';

const ConfirmLogoutModal: React.FC = () => {
    const { t } = useTranslation('base');
    const dispatch = useDispatch();
    const router = useRouter();

    const confirmLogoutClick = (event: React.MouseEvent) => {
        event.preventDefault();
        dispatch(doLogout());
        hideModal('logout');

        if (window.location.host.includes('localhost')) {
            router.push('/');
        } else {
            window.location.href = WOLFE_API;
        }
    };

    const cancelLogout = (event: React.MouseEvent) => {
        event.preventDefault();
        hideModal('logout');
    };

    return (
        <Modal id="logout">
            <style jsx>{styles}</style>
            <img
                width="35"
                className="absolute inline-block py-2 right-0 left-0 mr-auto ml-auto top-12"
                src={BoonButterflyIcon}
            />
            <div className="pt-8 text-center text-black text-sm">
                <p className="fr-book text-base font-bold pb-">{t('base:logout-modal-header')}</p>
                <p className="fr-book text-sm pb-8">{t('base:logout-modal-subheader')}</p>
            </div>
            <div className="flex flex-row justify-center items-center mb-2">
                <a
                    href=""
                    className="CancelLogoutButton text-black uppercase border-black border-solid border-b hover:border-transparent py-1 px-4 mr-4 font-gr-medium tracking-widest text-xxs"
                    onClick={cancelLogout}
                >
                    {t('cancel-link-text')}
                </a>
                <BoonButton
                    addtlContainerClasses="ConfirmLogoutButton"
                    style="dark"
                    height="h-8"
                    width="w-23"
                    type="link"
                    onClick={confirmLogoutClick}
                    font="uppercase font-gr-light tracking-widest font-hairline text-xxs"
                >
                    {t('logout-link-text')}
                </BoonButton>
            </div>
        </Modal>
    );
};

export default ConfirmLogoutModal;
